<script>
export default {
  async beforeRouteEnter(to, from, next) {
    const store = await import('@/store'); // adjust if store is global
    const config = await store.default.dispatch("auth/getAuthUser");
    const clientType = config.client?.client_type;

    next(vm => {
      vm.componentToRender = clientType === "4"
        ? () => import('@/views/Home_B_Plus.vue')
        : () => import('@/views/Home.vue');
    });
  },
  data() {
    return {
      componentToRender: null
    };
  },
  // mounted() {
  //   console.log("Component mounted");
  // },
  render(h) {
    return this.componentToRender ? h(this.componentToRender) : h('div', 'Loading...');
  }
};
</script>
